export default "__VITE_ASSET__q4H_mKGZ__"